import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiCalendar, HiMail } from 'react-icons/hi';
import Button from '../../components/ui/Button/Button';
import { useGeneral } from '../../contexts';
import { useErrorPage } from '../../contexts/ErrorPageContext';
import SEO from '../../components/SEO';
import styles from './UnauthorizedPage.module.css';

const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useGeneral();
  const { getTranslation } = language;
  const { setIsErrorPage } = useErrorPage();

  useEffect(() => {
    setIsErrorPage(true);
    return () => setIsErrorPage(false);
  }, [setIsErrorPage]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleExploreEvents = () => {
    navigate('/events');
  };

  const handleExploreLodos = () => {
    window.open('https://lodos.io', '_blank');
  };

  const handleContactUs = () => {
    window.location.href = 'mailto:info@lodos.io';
  };

  return (
    <>
      <SEO
        title={getTranslation('unauthorized.title') || 'Unauthorized Access'}
        description={getTranslation('unauthorized.description') || 'You do not have permission to access this page.'}
        url={typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : undefined}
        noindex
        lang={language.language}
      />
      <main className={styles.content}>
        <div className={styles.container}>
        <h1 className={styles.title}>403</h1>
        <h2 className={styles.subtitle}>
          {getTranslation('unauthorized.title') || 'Yetkisiz Erişim'}
        </h2>
        <p className={styles.description}>
          {getTranslation('unauthorized.description') || 
            'Bu topluluğun organizatör paneline erişim yetkiniz bulunmamaktadır. Sadece topluluk yöneticileri bu sayfaya erişebilir.'}
        </p>
        
        <div className={styles.actions}>
          <Button 
            variant="primary" 
            size="medium"
            onClick={handleGoHome}
          >
            {getTranslation('unauthorized.goHome') || 'Ana Sayfaya Dön'}
          </Button>
        </div>

        <div className={styles.sections}>
          <div className={styles.sectionCard} onClick={handleExploreEvents}>
            <div className={`${styles.icon} ${styles.iconOrange}`}>
              {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
              {/* @ts-ignore - react-icons compatibility with React 19 */}
              <HiCalendar size={32} />
            </div>
            <h3 className={styles.sectionTitle}>
              {getTranslation('notFound.exploreEvents') || 'Explore Events'}
            </h3>
            <p className={styles.sectionSubtitle}>
              {getTranslation('notFound.exploreEventsSubtitle') || "Let's join"}
            </p>
          </div>

          <div className={styles.sectionCard} onClick={handleExploreLodos}>
            <div className={styles.lodosIconWrapper}>
              <img src="/lodos-favicon.png" alt="Lodos" className={styles.lodosIcon} />
            </div>
            <h3 className={styles.sectionTitle}>
              {getTranslation('notFound.exploreLodos') || 'Explore Lodos'}
            </h3>
            <p className={styles.sectionSubtitle}>
              {getTranslation('notFound.exploreLodosSubtitle') || 'Connect people'}
            </p>
          </div>

          <div className={styles.sectionCard} onClick={handleContactUs}>
            <div className={`${styles.icon} ${styles.iconGreen}`}>
              {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
              {/* @ts-ignore - react-icons compatibility with React 19 */}
              <HiMail size={32} />
            </div>
            <h3 className={styles.sectionTitle}>
              {getTranslation('notFound.contactUs') || 'Contact Us'}
            </h3>
            <p className={styles.sectionSubtitle}>
              {getTranslation('notFound.contactUsSubtitle') || 'Ask a question'}
            </p>
          </div>
        </div>
        </div>
      </main>
    </>
  );
};

export default UnauthorizedPage;

